import { actions as entityActions } from '../../../data/store';
import { getCustomerContracts, updateByCustomer } from '../../../entities/contracts/actions';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../../store/actions';
import { ThunkAction } from '../../../store/middleware';
import { buildCancellationPreference } from './home/helpers';
import { IMarketingPreferences } from './home/types';

export const getMarketingPreferencesActions = createActionCreators<
	{ T: 'GET_MARKETING_PREFERENCES_REQUEST', P: string },
	{ T: 'GET_MARKETING_PREFERENCES_RECEIVE', P: string },
	{ T: 'GET_MARKETING_PREFERENCES_FAILURE', P: { id: string, error: Error } }
>('GET_MARKETING_PREFERENCES_REQUEST', 'GET_MARKETING_PREFERENCES_RECEIVE', 'GET_MARKETING_PREFERENCES_FAILURE');

export const getMarketingPreferences = (customerId: string): ThunkAction => async (dispatch) => {
	dispatch(getMarketingPreferencesActions.GET_MARKETING_PREFERENCES_REQUEST(customerId));
	try {
		await Promise.all([
			dispatch(getCustomerContracts(customerId)),
			dispatch(entityActions.cancellationPreference.getByCustomer(customerId))
		]);
		dispatch(getMarketingPreferencesActions.GET_MARKETING_PREFERENCES_RECEIVE(customerId));
	} catch (e) {
		dispatch(getMarketingPreferencesActions.GET_MARKETING_PREFERENCES_FAILURE({ id: customerId, error: e }));
	}
};

export const changeMarketingPreferencesActions = createActionCreators<
	{ T: 'CHANGE_MARKETING_PREFERENCES_REQUEST', P: string },
	{ T: 'CHANGE_MARKETING_PREFERENCES_RECEIVE', P: { id: string, marketingPreferences: IMarketingPreferences } },
	{ T: 'CHANGE_MARKETING_PREFERENCES_FAILURE', P: { id: string, error: Error } },
	{ T: 'UI_CHANGED', P: { id: string, marketingPreferences: IMarketingPreferences } }
>('CHANGE_MARKETING_PREFERENCES_REQUEST', 'CHANGE_MARKETING_PREFERENCES_RECEIVE', 'CHANGE_MARKETING_PREFERENCES_FAILURE', 'UI_CHANGED');

export const changeMarketingPreferences = (customerId: string, marketingPreferences: IMarketingPreferences):
	ThunkAction => (dispatch) => {
		dispatch(changeMarketingPreferencesActions.CHANGE_MARKETING_PREFERENCES_REQUEST(customerId));
		try {
			dispatch(changeMarketingPreferencesActions.CHANGE_MARKETING_PREFERENCES_RECEIVE({ id: customerId, marketingPreferences }));
		} catch (e) {
			dispatch(changeMarketingPreferencesActions.CHANGE_MARKETING_PREFERENCES_FAILURE({ id: customerId, error: e }));
		}
	};

export const updateMarketingPreferencesActions = createActionCreators<
	{ T: 'UPDATE_MARKETING_PREFERENCES_REQUEST', P: string },
	{ T: 'UPDATE_MARKETING_PREFERENCES_RECEIVE', P: string },
	{ T: 'UPDATE_MARKETING_PREFERENCES_FAILURE', P: { id: string, error: Error } }
>('UPDATE_MARKETING_PREFERENCES_REQUEST', 'UPDATE_MARKETING_PREFERENCES_RECEIVE', 'UPDATE_MARKETING_PREFERENCES_FAILURE');

export const updateMarketingPreferences = (customerId: string, marketingPreferences: IMarketingPreferences):
	ThunkAction => async (dispatch, getState) => {
		dispatch(updateMarketingPreferencesActions.UPDATE_MARKETING_PREFERENCES_REQUEST(customerId));
		try {
			await dispatch(entityActions.cancellationPreference.
				updateByRecipient(customerId, buildCancellationPreference(customerId, marketingPreferences.cancellationPolicy)));
			await dispatch(updateByCustomer(customerId, marketingPreferences.contracts));
			dispatch(updateMarketingPreferencesActions.UPDATE_MARKETING_PREFERENCES_RECEIVE(customerId));
		} catch (e) {
			dispatch(updateMarketingPreferencesActions.UPDATE_MARKETING_PREFERENCES_FAILURE({ id: customerId, error: e }));
		}
	};

const actions = { ...getMarketingPreferencesActions, ...changeMarketingPreferencesActions, ...updateMarketingPreferencesActions, };
type MarketingPreferencesActions = ActionValues<typeof actions>;
type MarketingPreferencesActionTypes = ActionTypeNames<MarketingPreferencesActions>;
export type Actions = MarketingPreferencesActions[keyof MarketingPreferencesActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as MarketingPreferencesActionTypes);
